import { Checkbox, type CheckboxProps } from "antd";
import type { ReactNode } from "react";
import { FormItem, type FormItemProps } from "../FormItem";
import "./FormCheckbox.scss";

type Props<TForm> = FormItemProps<TForm> & {
  label?: ReactNode;

  /** `disabled` moved out of `checkboxProps` for convenience as it used frequently */
  disabled?: boolean;
  /** Antd `SelectProps` */
  checkboxProps?: Omit<CheckboxProps, "disabled">;
};

export const FormCheckbox = <TForm = unknown>({ label, disabled, checkboxProps, ...rest }: Props<TForm>) => {
  const content = (
    <>
      <FormItem<TForm> label={label} colon={false} valuePropName="checked" {...rest} layout="horizontal">
        <Checkbox disabled={disabled} {...checkboxProps} />
      </FormItem>
    </>
  );

  return rest.hidden ? content : <div className="form-checkbox">{content}</div>;
};
